import { css } from 'styled-components';
import { math } from 'polished';
import { SDS_SIZE_BORDER_SMALL } from '@s-group/design-system-tokens/web/tokens/size.es6.js';
import * as spaceTokens from '@s-group/design-system-tokens/web/tokens/space.es6.js';

const lineWidth = SDS_SIZE_BORDER_SMALL;
const spacing = ({ spacing }) => spacing
    ? spaceTokens[`SDS_SPACE_${spacing.toUpperCase()}`]
    : '0';
const nonRetinaTopMargin = spacing;
const nonRetinaBottomMargin = (props) => math(`${spacing(props)} - ${lineWidth}`);
const retinaVerticalMargin = (props) => math(`${spacing(props)} - ${lineWidth} / 2`);
const DividerStyle = css `
    border: none; /* override browser default */
    border-bottom: ${lineWidth} solid
        ${({ role, theme }) => role === 'presentation'
    ? theme.colors.SDS_BRAND_COLOR_BORDER_WEAK_GREY
    : theme.colors.SDS_BRAND_COLOR_BORDER_DEFAULT_GREY};
    margin: ${nonRetinaTopMargin} 0 ${nonRetinaBottomMargin} 0;

    @media (min-resolution: 150dpi) {
        margin: ${retinaVerticalMargin} 0;
    }
`;

export { DividerStyle };
//# sourceMappingURL=Divider.styles.js.map
